import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { NotificationService, Notification } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationDeviceTokensService {
  constructor(private angularFirestore: AngularFirestore) { }

  async upsertDevice(
    token: string,
    deviceUpsertParams: {
      id?: string;
      token?: string;
      userId?: string;
    } = {}
  ) {
    const splitToken = token.split(':');
    const tokenId = splitToken[0];
    deviceUpsertParams.id = tokenId;
    deviceUpsertParams.token = token;

    const upsertedToken = await this.angularFirestore
      .collection('NotificationDeviceTokens')
      .doc(tokenId)
      .set(deviceUpsertParams, {
        merge: true,
      });
    return upsertedToken;
  }
}
